<script>
  export let size = "14";
  export let color = "#FDFDFD";
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 14 14"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M7 0L7.36035 0.00878906C11.0589 0.196329 14 3.25486 14 7C14 10.866 10.866 14 7 14C3.13401 14 6.44277e-08 10.866 0 7C0 3.13401 3.13401 0 7 0ZM1.30957 7.63672C1.57275 10.0154 3.29098 11.9545 5.55566 12.543C4.58379 11.0826 3.99538 9.39539 3.85254 7.63672H1.30957ZM10.1475 7.63672C10.0046 9.39561 9.41546 11.0825 8.44336 12.543C10.7085 11.9548 12.4272 10.0157 12.6904 7.63672H10.1475ZM5.12891 7.63672C5.28905 9.36208 5.93847 11.0056 7 12.374C8.06153 11.0056 8.71106 9.36209 8.87109 7.63672H5.12891ZM8.44336 1.45605C9.41573 2.91672 10.0046 4.60412 10.1475 6.36328H12.6904C12.4272 3.98422 10.7086 2.04415 8.44336 1.45605ZM7 1.62598C5.9384 2.9944 5.289 4.63781 5.12891 6.36328H8.87109C8.7111 4.63775 8.06167 2.99443 7 1.62598ZM5.55566 1.45605C3.29087 2.04443 1.57276 3.98454 1.30957 6.36328H3.85254C3.9954 4.60434 4.58352 2.91659 5.55566 1.45605Z"
    style="fill: {color} !important;"
  />
</svg>
